import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=2b043271&scoped=true&"
import script from "./Upload.vue?vue&type=script&lang=js&"
export * from "./Upload.vue?vue&type=script&lang=js&"
import style0 from "./assets/css/upload.scss?vue&type=style&index=0&id=2b043271&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b043271",
  null
  
)

export default component.exports